import stylesConfig from "../styles.config";
import globalVariables from "../partials/global-variables";

export default {
  container: {
    textAlign: "center",
    margin: ["5px", 0],
    "& .rating__star": {
      margin: "1px",
    },
  },
  iconStarEmpty: {
    "& .icon__fill": {
      fill: stylesConfig.colors.secondary.spectrum100,
      transform: "fill 0.5s ease 0s",
      ".product:hover &": {
        fill: globalVariables.colors.white,
      },
    },
    "& .icon__stroke": {
      display: "none",
    },
  },
  iconStarFilled: {
    extends: "iconStarEmpty",
    "& .icon__fill.icon__fill--full": {
      fill: stylesConfig.colors.primary.spectrum500,
    },
    "& .icon__fill.icon__fill--half": {
      display: "none",
    },
    "& .icon__stroke": {
      display: "none",
    },
  },
  iconStarHalf: {
    extends: "iconStarEmpty",
    "& .icon__fill.icon__fill--full": {
      fill: stylesConfig.colors.secondary.spectrum100,
      ".product:hover &": {
        fill: globalVariables.colors.white,
      },
    },
    "& .icon__fill.icon__fill--half": {
      fill: stylesConfig.colors.primary.spectrum500,
    },
    "& .icon__stroke": {
      display: "none",
    },
  },
};
